import { useEffect, type RefObject } from "react";

/**
 * `onOutside` hívása, ha `active` mellett a felhasználó a `ref` elemen kívülre kattint/koppint.
 * Nem modális felületekhez (lenyíló menü, popover-szerű panel), ahol nincs overlay.
 */
export function useClickOutside(
  ref: RefObject<HTMLElement | null>,
  active: boolean,
  onOutside: () => void,
): void {
  useEffect(() => {
    if (!active) return;
    const onPointerDown = (event: PointerEvent) => {
      if (!ref.current?.contains(event.target as Node)) onOutside();
    };
    document.addEventListener("pointerdown", onPointerDown);
    return () => document.removeEventListener("pointerdown", onPointerDown);
  }, [ref, active, onOutside]);
}
